module.exports = __webpack_public_path__ + "img/export5.31836d81.png";